import { jsxs, jsx } from 'react/jsx-runtime';
import classnames from '../../node_modules/classnames/index.js';
import { forwardRef } from 'react';
import modules_e20967e9 from './Link.module.scss.js';
import ExternalLink16 from '../../packages/constellation-components/node_modules/@trustpilot/icons/lib/external-link_16.svg.js';
import { Typography } from '../Typography/Typography.js';
import { Icon } from '../Icon/Icon.js';

const Link = forwardRef((props, ref) => {
    const { "aria-current": ariaCurrent, "aria-label": ariaLabel, as, appearance, children, className, "data-testid": testId, disabled, external, href, onClick, rel, underline = true, variant = "inherit", target, title, ...rest } = props;
    return (jsxs(Typography, { as: as || "a", appearance: appearance ? appearance : disabled ? "disabled" : "action", "aria-current": ariaCurrent, "aria-label": ariaLabel, className: classnames(modules_e20967e9.link, className, {
            [modules_e20967e9.asButton]: as === "button",
            [modules_e20967e9.buttonInherit]: as === "button" && variant === "inherit",
            [modules_e20967e9.disabled]: disabled,
            [modules_e20967e9.noUnderline]: !underline,
            [modules_e20967e9.underline]: underline,
            [modules_e20967e9.external]: external,
        }), "data-testid": testId, disabled: disabled, ...(disabled
            ? { "aria-disabled": true, role: "link" }
            : { href, onClick }), ref: ref, rel: Array.isArray(rel) ? rel.join(" ") : rel, target: target, title: title, variant: variant, ...rest, children: [children, external && (jsx(Icon, { appearance: "inherit", content: ExternalLink16, ...(testId ? { "data-testid": `${testId}-icon` } : {}) }))] }));
});

export { Link };
//# sourceMappingURL=Link.js.map
